module.exports = __webpack_public_path__ + "media/splash/launch-640x1136-b8332c4c.png";